<template>
  <div>
    <register></register>
  </div>
</template>

<script>
import auth from '@/utils/auth';
import { baseset } from '@/api/login';
export default {
  created() {
    if (auth.getCookie('skin')) {
      if (Number(this.$util.iEVersion()) === 15) {
        this.$util.setColor(
          auth.getCookie('skin'),
          auth.getCookie('skin'),
          '#409EFF'
        );
      }
    } else {
      this.$util.setColor('#1f69e6', '#1f69e6', '#409EFF');
    }
    // 在页面加载的时候就获取左侧菜单避免页面闪烁
    this.getBaseset();
  },
  methods: {
    getBaseset() {
      const params = {
        channel: 'PC',
        userid: auth.getCookie('User-Id')
      };

      baseset(params).then((res) => {
        if (res.data) {
          document.title = res.data.sysname;
          auth.setLocalStorage('iconurl', res.data.iconurl);
          this.$util.setTitleIcon(res.data.iconurl);
        }
      });
    }
  }
};
</script>